import styled from 'styled-components';

export const ToggleInput = ({ value, onChange }: { value?: boolean; onChange: (newValue?: boolean) => void }) => {
  return (
    <Container>
      <Toggle $isActive={value === true} onClick={() => onChange(value !== undefined ? !value : undefined)}>
        <Circle $isActive={value === true} />
      </Toggle>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Toggle = styled.div<{ $isActive?: boolean }>`
  cursor: pointer;
  position: relative;
  width: 40px;
  height: 24px;
  border-radius: 13px;
  border: 1px solid var(--neutral-3);
  background-color: var(--neutral-2);

  transition: background-color var(--transition-1);
  &:hover {
    background-color: var(--neutral-3);
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    background-color: var(--primary-2);
    &:hover {
      background-color: var(--primary-2);
    }
    `}
`;

const Circle = styled.div<{ $isActive?: boolean }>`
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--main-2);

  transition: left var(--transition-1);
  ${({ $isActive }) =>
    $isActive &&
    `
    background-color: var(--main-1);
    left: 18px;
  `}
`;
